var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { map, switchMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import * as ContactsActions from '../actions/contacts.action';
import { ContactsActionTypes } from '../actions/contacts.action';
import { ContactsService } from '@core/service/contacts.service';
export class ContactsEffects {
    constructor(actions$, contactsService) {
        this.actions$ = actions$;
        this.contactsService = contactsService;
        this.loadContacts$ = this.actions$.pipe(ofType(ContactsActionTypes.ContactsLoad), switchMap(() => {
            return this.contactsService.getContacts().pipe(map(contacts => new ContactsActions.ContactsLoadSuccess(contacts)), catchError(error => of(new ContactsActions.ContactsLoadFail(error))));
        }));
    }
}
__decorate([
    Effect(),
    __metadata("design:type", Object)
], ContactsEffects.prototype, "loadContacts$", void 0);
